import { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import TableSortLabel from "@mui/material/TableSortLabel";
import TextField from "@mui/material/TextField";
import {
  List,
  ListItem,
  ListItemText,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import axios from "axios";

import DeleteIcon from "@mui/icons-material/Delete";
import InputAdornment from "@mui/material/InputAdornment";
import { IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAcademicYear } from "./AcademicYearContext";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0A64A2",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function EventProductIssue({
  setOpenIssueComponent,
  SelectedEventissueProductId,
  onRefresh,
  setopenEditComponent,
}) {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [product, setProduct] = useState([]);
  const [issueProductId, setIssueProductId] = useState(null);
  const [userId, setUserId] = useState();
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("issue_product_details_id");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [tableData, setTableData] = useState([]);
  const [selectedQuantity, setSelectedQuantity] = useState({});
  const [validationErrors, setValidationErrors] = useState(false);
  const [currentQuantity, setCurrentQuantity] = useState({});
  const [markedForDelete, setMarkedForDelete] = useState([]);
  const [issuedStatusId, setIssuedStatusId] = useState(null);
  const [createdStatusId, setCreatedStatusId] = useState(null);
  const [openProduct, setOpenProduct] = useState(false);
  const [error, setError] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [searchResultsForEvent, setSearchResultsForEvent] = useState([]);
  const [EventName, setEventName] = useState();
  const [EventCategoryName, setEventCategoryName] = useState("");
  const [EventId, setEventId] = useState();
  const [openstaff, setOpenstaff] = useState(false);
  const [loadingProduct, setLoadingProduct] = useState(false);
  const [needsReturn, setNeedsReturn] = useState(true);
  const [openNeedsReturn, setOpenNeedsReturn] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  const [AllEvent, setAllEvent] = useState([]);

  const [LoadingEvents, setLoadingEvents] = useState(false);
  const [searchEvent, setSearchEvent] = useState("");
  const [indentId, setIndentId] = useState("");

  const [open, setOpen] = useState(false);
  const [infoDialog, setInfoDialog] = useState(false);
  const [description, setDescription] = useState("");
  const [saleStatus, setSaleStatus] = useState([]);
  const [productSearchError, setProductSearchError] = useState("");

  const { academicYearId } = useAcademicYear();

  const getSaleStatus = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/createProduct/getSalesStatus`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        },
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      console.log("Fetched data:", data);

      const issuedStatus =
        data.find((item) => item.description === "Issued")
          ?.issue_product_status_id || null;

      const createdStatus =
        data.find((item) => item.description === "Created")
          ?.issue_product_status_id || null; // ✅ Add this line

      console.log("Issued Sale Status ID:", issuedStatus);

      // Set the complete data and the extracted IDs in state
      setSaleStatus(data);
      setIssuedStatusId(issuedStatus);
      // setRefundedStatusId(refundedStatus);
      setCreatedStatusId(createdStatus); // ✅ Add this line
    } catch (error) {
      console.error("Error fetching sales status:", error);
    }
  };

  useEffect(() => {
    getSaleStatus();
  }, []);

  useEffect(() => {
    console.log("Received Academic Year ID:", academicYearId);
  }, [academicYearId]);

  const handleCloseNeedsReturn = () => {
    setOpenNeedsReturn(false);
  };

  const handleClosestaff = () => {
    setOpenstaff(false);
  };

  useEffect(() => {
    const fetchUserData = async () => {
      const email = localStorage.getItem("user_email");
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/profile/profiledata`,
          { email },
          { headers: { user_email: email } },
        );
        if (response.status === 200) {
          setUserId(response.data.user.user_id);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchUserData();
  }, []);

  useEffect(() => {
    const fetchProducts = async () => {
      setLoadingProduct(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/getsearchresult`,
        );
        if (!response.ok) throw new Error("Failed to fetch products");
        const data = await response.json();
        setAllProducts(Array.isArray(data) ? data : []);
        // setSearchResults([]); // initially show nothing
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoadingProduct(false);
      }
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    const searchTerms = searchQuery.toLowerCase().split(" ").filter(Boolean);

    // Line ~185: filter useEffect — add guard
    const filtered = (Array.isArray(allProducts) ? allProducts : []).filter(
      (row) =>
        searchTerms.every(
          (term) =>
            (row.product_id &&
              row.product_id.toString().toLowerCase().includes(term)) ||
            (row.product_name &&
              row.product_name.toLowerCase().includes(term)) ||
            (row.brand_name && row.brand_name.toLowerCase().includes(term)) ||
            (row.attribute_name &&
              row.attribute_name.toLowerCase().includes(term)) ||
            (row.attribute_value &&
              row.attribute_value.toLowerCase().includes(term)) ||
            (row.price && row.price.toString().toLowerCase().includes(term)) ||
            (row.quantity &&
              row.quantity.toString().toLowerCase().includes(term)),
        ),
    );
    setSearchResults(filtered);
    console.log("serached results in filere ", filtered);
  }, [searchQuery, allProducts]);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleInput = () => {
    setOpenstaff(true);
  };

  const handleSearchForEvent = (event) => {
    setSearchEvent(event.target.value);
  };

  const handleProductSelect = async (product) => {
    console.log("Selected product from search:", product);
    try {
      // Duplicate check in UI (backend also validates)
      const isAlreadyAdded = tableData.some(
        (item) => item.product_id === product.product_id,
      );
      if (isAlreadyAdded) {
        setError("This product is already added.");
        setSnackbarOpen(true);
        return;
      }

      // Stock check
      if (product.quantity <= 0) {
        setError("This product is out of stock.");
        setSnackbarOpen(true);
        return;
      }

      // API call to insert
      const res = await axios.post(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/events/addeventSale`,
        {
          academicYearId: academicYearId,
          event_id: EventId,
          product_id: product.product_id,
          quantity: 1,
          return_quantity: 0,
          event_issue_product_decription: description,
          created_by: userId,
        },
        { withCredentials: true },
      );

      if (res.status === 409) {
        setError(
          res.data.message || "This product is already issued for this event.",
        );
        setSnackbarOpen(true);
        return;
      }

      if (!res.data || !res.data.event_issue_product_details_id) {
        throw new Error("Invalid response from server.");
      }

      console.log("API response:", res.data);

      // ✅ FIX: Set the indent ID from the first product's response
      if (!indentId && res.data.event_issue_product_id) {
        setIndentId(res.data.event_issue_product_id);
        setIssueProductId(res.data.event_issue_product_id); // ✅ ADD THIS
      }

      // Add to table data
      setTableData((prev) => [...prev, res.data]);

      setProductSearchError(""); // Clear any previous errors
      // Clear search bar and results after adding
      setSearchQuery("");
      setSearchResults([]);
    } catch (err) {
      console.error("Error adding product:", err);
      setError("This product is already added.");
      setSnackbarOpen(true);
    }
  };

  useEffect(() => {
    console.log("Updated tableData:", tableData);
  }, [tableData]);

  const handleEventSelect = async (staff) => {
    console.log("staff id", staff.event_id);
    setEventId(staff.event_id);
    setEventName(staff.event_name);
    setSearchEvent("");
    setEventCategoryName(staff.event_category_name);
    setSearchResultsForEvent([]);
    setError("");
    setIssueProductId(null);
    setNeedsReturn(true);

    // ✅ Fetch existing "Created" products for this event
    const existingProducts = await fetchExistingEventProducts(staff.event_id);

    if (existingProducts && existingProducts.length > 0) {
      // Set the existing products in table
      setTableData(existingProducts);

      // ✅ FIXED: Use setIndentId instead
      if (existingProducts[0].event_issue_product_id) {
        setIndentId(existingProducts[0].event_issue_product_id);
        setIssueProductId(existingProducts[0].event_issue_product_id); // ✅ ADD THIS LINE
      }

      // Set description if exists
      if (existingProducts[0].event_description) {
        setDescription(existingProducts[0].event_description);
      }
    } else {
      // No existing products, start fresh
      setTableData([]);
      setIndentId("");
      setIssueProductId(null); // ✅ ADD THIS LINE
      setDescription("");
    }
  };
  useEffect(() => {
    console.log("product searchReasult", allProducts);
  }, [allProducts]);

  useEffect(() => {
    console.log("product sorted data in issueproduct tab", sortedData);
  }, [tableData]);

  const handleCloseSnackbar = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = () => {
    return tableData.slice().sort((a, b) => {
      const aValue = a[orderBy];
      const bValue = b[orderBy];
      if (aValue < bValue) return order === "asc" ? -1 : 1;
      if (aValue > bValue) return order === "asc" ? 1 : -1;
      return 0;
    });
  };

  // Handle pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleQuantityChange = async (
    eipd_id,
    value,
    maxQuantity,
    productId,
  ) => {
    // Parse the input to a number
    const numericValue = parseInt(value, 10);

    // Step 1: Validation checks
    if (value === "" || isNaN(numericValue)) {
      setValidationErrors((prev) => ({
        ...prev,
        [eipd_id]: `Quantity is required and must be between 1 and ${maxQuantity}`,
      }));
      setSelectedQuantity((prev) => ({
        ...prev,
        [eipd_id]: "",
      }));
      return;
    }

    if (numericValue < 1) {
      setValidationErrors((prev) => ({
        ...prev,
        // [salesDetailsId]: "Quantity must be at least 1.",
      }));
      return;
    }

    if (numericValue > maxQuantity) {
      setValidationErrors((prev) => ({
        ...prev,
        [eipd_id]: `Quantity cannot exceed available stock.`,
      }));
      return;
    }

    // Step 2: Clear validation errors if all checks pass
    setValidationErrors((prev) => ({
      ...prev,
      [eipd_id]: null,
    }));

    // Step 3: Update the selected quantity in the local state
    setSelectedQuantity((prev) => ({
      ...prev,
      [eipd_id]: numericValue,
    }));

    try {
      const saveQuantity = async (detailId, quantity) => {
        const res = await fetch(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/events/updateEventIssueProductDetailQuantity`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({
              event_issue_product_details_id: detailId,
              quantity: quantity,
            }),
          },
        );

        if (!res.ok) {
          throw new Error("Failed to update sales data");
        }
        return res;
      };

      // Call the function with proper arguments
      await saveQuantity(eipd_id, numericValue);

      // Update local state after success
      setCurrentQuantity((prev) => ({
        ...prev,
        [eipd_id]: numericValue,
      }));
    } catch (error) {
      console.error("Error updating quantity:", error);
    }
  };

  // SINGLE ROW DELETE (from icon)
  const handleRowDeleteClick = (detailId) => {
    setMarkedForDelete((prev) => {
      if (prev.includes(detailId)) {
        // If already selected, remove it
        return prev.filter((id) => id !== detailId);
      } else {
        // If not selected, add it
        return [...prev, detailId];
      }
    });
  };

  const handleConfirmDelete = () => {
    handleDeleteProduct();
    setTableData((prev) =>
      prev.filter(
        (item) =>
          !markedForDelete.includes(item.event_issue_product_details_id),
      ),
    );

    setMarkedForDelete([]); // clear selection after delete
    setOpen(false);
  };
  const handleDeleteClick = () => {
    if (!tableData || tableData.length === 0) {
      // ❌ No product search results
      setInfoDialog(true);
      return;
    }

    // ✅ If products exist, go to delete flow
    handleBatchDelete();
  };

  const handleBatchDelete = () => {
    setOpen(true); // ✅ open confirmation dialog here
  };

  // Close dialog
  const handleClose = () => {
    setOpen(false);
  };

  // Delete confirmed
  // const handleConfirmDelete = () => {
  //   handleDeleteProduct(); // your delete function
  //   setOpen(false);
  // };
  // ACTUAL DELETE API CALL
  const handleDeleteProduct = async () => {
    try {
      for (let detailId of markedForDelete) {
        const res = await fetch(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/events/deleteEventIssueProductDetail`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ event_issue_product_details_id: detailId }),
          },
        );

        const data = await res.json();
        if (!res.ok) throw new Error(data.message || "Delete failed");
      }

      // Remove deleted rows from UI
      setTableData((prev) =>
        prev.filter(
          (item) =>
            !markedForDelete.includes(item.event_issue_product_details_id),
        ),
      );

      setMarkedForDelete([]);
      setOpen(false);
    } catch (err) {
      console.error("Error deleting product:", err);
    }
  };

  const saveQuantity = async (detailId, quantity) => {
    await fetch(
      `${process.env.REACT_APP_JHS_DEVELOPMENT}/events/updateEventIssueProductDetailQuantity`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          event_issue_product_details_id: detailId,
          quantity,
        }),
      },
    );

    setOpenIssueComponent(false); // close dialog
  };

  const handleOk = async () => {
    console.log("handle ok function clicked");
    // ✅ Validation: Check if staff is selected but no products
    if (EventName && tableData.length === 0) {
      setProductSearchError("Please select product(s) before proceeding.");
      return;
    }

    try {
      // Determine which issue_product_id to use
      let activeIssueProductId;

      if (SelectedEventissueProductId) {
        activeIssueProductId = SelectedEventissueProductId;
      } else if (indentId) {
        activeIssueProductId = indentId;
      } else if (issueProductId) {
        activeIssueProductId = issueProductId;
      }

      // ✅ If no ID found, just close modal quietly (no API call, no error)
      if (!activeIssueProductId) {
        console.log("No issue_product_id found — closing modal silently.");
        setOpenIssueComponent(false);
        if (setopenEditComponent) setopenEditComponent(false);
        return;
      }

      // ✅ Proceed with API call only if ID exists
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/events/updatedescription`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            issueProductId: activeIssueProductId,
            issue_description: description,
          }),
        },
      );

      // ✅ Close modal whether success or failure
      setOpenIssueComponent(false);
      if (setopenEditComponent) setopenEditComponent(false);

      // Optional: refresh data if callback provided
      if (onRefresh) {
        await onRefresh();
      }
    } catch (error) {
      console.error("🔥 Error in handleOk:", error);
      // ✅ Still close modal quietly even if an error occurs
      setOpenIssueComponent(false);
      if (setopenEditComponent) setopenEditComponent(false);
    }
  };

  useEffect(() => {
    const fetchAllEvents = async () => {
      setLoadingEvents(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/events/getEvents`,
        );
        if (!response.ok) throw new Error("Failed to fetch event");
        const data = await response.json();
        setAllEvent(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Error fetching staff:", error);
      } finally {
        setLoadingEvents(false);
      }
    };

    fetchAllEvents();
  }, []);

  useEffect(() => {
    const searchTerms = searchEvent.toLowerCase().split(" ").filter(Boolean);

    const filtered = AllEvent.filter((row) =>
      searchTerms.every(
        (term) =>
          (row.event_id &&
            row.event_id.toString().toLowerCase().includes(term)) ||
          (row.event_name && row.event_name.toLowerCase().includes(term)) ||
          (row.event_category_name &&
            row.event_category_name.toLowerCase().includes(term)) ||
          (row.event_description &&
            row.event_description.toLowerCase().includes(term)),
      ),
    );

    setSearchResultsForEvent(filtered);
  }, [searchEvent, AllEvent]);

  const fetchExistingEventProducts = async (eventId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/events/getExistingEventProducts`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            event_id: eventId,
            academic_year_id: academicYearId,
            status: 1, // Created status
          }),
        },
      );

      if (!response.ok) return [];

      const data = await response.json();
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error("Error fetching existing event products:", error);
      return [];
    }
  };
  return (
    <div>
      {
        <div className="create_search">
          {/* Search Field and Proceed Button */}
          <div style={{ display: "flex" }}>
            <div className="create_search1">
              <TextField
                sx={{ minWidth: 700, marginBottom: "4px" }}
                label="Event Search"
                variant="outlined"
                fullWidth
                value={searchEvent}
                onChange={handleSearchForEvent}
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconButton type="button" aria-label="search">
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      {LoadingEvents ? <CircularProgress size={18} /> : null}
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </div>
        </div>
      }

      {searchEvent.trim() !== "" && searchResultsForEvent.length > 0 && (
        <List
          sx={{
            border: "1px solid #ccc",
            borderRadius: "4px",
            padding: "0",
            width: 600,
          }}
        >
          {searchResultsForEvent.map((event) => (
            <ListItem
              button
              key={event.event_id}
              onClick={() => handleEventSelect(event)}
            >
              <ListItemText primary={event.event_id} />
              <ListItemText primary={event.event_category_name} />
              <ListItemText primary={event.event_name} />
              <ListItemText primary={event.event_description} />
            </ListItem>
          ))}
        </List>
      )}

      <div className="main_title1">
        Event Name: {EventName} &nbsp;&nbsp; Event Category: {EventCategoryName}
      </div>
      <div>
        <TextField
          label="Description"
          multiline
          rows={2} // 1.5 is not a valid value; use whole numbers like 2
          variant="outlined"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          sx={{
            minWidth: 700,
            marginTop: "25px",
            "& .MuiOutlinedInput-root": {
              padding: "8px",
            },
            "& .MuiInputLabel-root": {
              color: "#484f53ff",
            },
          }}
        />
      </div>
      <div
        style={{
          margin: "20px 0",
          fontSize: 15,
          fontWeight: "bold",
          color: "#0A64A2",
          paddingTop: "0",
        }}
      >
        Indent ID:{" "}
        {tableData.length > 0 ? indentId || SelectedEventissueProductId : ""}
      </div>

      <div className="create_search">
        {/* Search Field and Proceed Button */}
        <div style={{ display: "flex" }}>
          <div
            className="create_search1"
            style={{ display: "flex", alignItems: "center", gap: "10px" }}
          >
            <TextField
              sx={{ minWidth: 700, marginBottom: "4px" }}
              // label="Product Search"
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={EventId ? handleSearchChange : handleInput} // Conditional onChange
              label={productSearchError ? productSearchError : "Product Search"}
              error={!!productSearchError}
              size="small"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton type="button" aria-label="search">
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    {loadingProduct ? <CircularProgress size={18} /> : null}
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div className="sale-div">
            <div className="sale-delete-div">
              <Button
                variant="contained"
                color="primary"
                onClick={handleOk}
                className="sale-delete-btn"
              >
                OK
              </Button>

              <Button
                variant="contained"
                color="primary"
                onClick={handleDeleteClick}
                className="sale-delete-btn"
              >
                Delete
              </Button>
            </div>
          </div>
        </div>

        {/* Search Results List */}
        {searchQuery.trim() !== "" && searchResults.length > 0 && (
          <List
            sx={{
              border: "1px solid #ccc",
              borderRadius: "4px",
              padding: "0",
              width: 700,
            }}
          >
            {searchResults.map((product) => (
              <ListItem
                button
                key={product.product_id}
                onClick={() => handleProductSelect(product)}
              >
                <ListItemText primary={product.product_name} />
                <ListItemText primary={product.attribute_name} />
                <ListItemText primary={product.attribute_value} />
                <ListItemText primary={product.price} />
                <ListItemText primary={product.quantity} />
              </ListItem>
            ))}
          </List>
        )}
      </div>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 750 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>
                <TableSortLabel
                  active={orderBy === "issue_product_details_id"}
                  direction={
                    orderBy === "issue_product_details_id" ? order : "asc"
                  }
                  onClick={() => handleSort("issue_product_details_id")}
                >
                  Sl.No
                </TableSortLabel>
              </StyledTableCell>
              <StyledTableCell align="center">
                <TableSortLabel
                  active={orderBy === "product_name"}
                  direction={orderBy === "product_name" ? order : "asc"}
                  onClick={() => handleSort("product_name")}
                >
                  Product Name
                </TableSortLabel>
              </StyledTableCell>
              <StyledTableCell align="center">
                <TableSortLabel
                  active={orderBy === "attribute_name"}
                  direction={orderBy === "attribute_name" ? order : "asc"}
                  onClick={() => handleSort("attribute_name")}
                >
                  Attribute Name
                </TableSortLabel>
              </StyledTableCell>
              <StyledTableCell align="center">
                <TableSortLabel
                  active={orderBy === "attribute_value"}
                  direction={orderBy === "attribute_value" ? order : "asc"}
                  onClick={() => handleSort("attribute_value")}
                >
                  Attribute Value{" "}
                </TableSortLabel>
              </StyledTableCell>

              <StyledTableCell align="center">Quantity </StyledTableCell>

              <StyledTableCell align="center">
                <TableSortLabel
                  active={orderBy === "quantity"}
                  direction={orderBy === "quantity" ? order : "asc"}
                  onClick={() => handleSort("quantity")}
                >
                  Quantity In Stock
                </TableSortLabel>
              </StyledTableCell>

              <StyledTableCell align="center"></StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData()
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                const isMarked = markedForDelete.includes(
                  row.event_issue_product_details_id,
                );

                return (
                  <StyledTableRow key={row.event_issue_product_details_id}>
                    <StyledTableCell
                      align="center"
                      className="table-cell-border"
                    >
                      {row.event_issue_product_details_id}
                      {isMarked && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>

                    <StyledTableCell
                      align="center"
                      className="table-cell-border"
                    >
                      {row.product_name}
                      {isMarked && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>

                    <StyledTableCell
                      align="center"
                      className="table-cell-border"
                    >
                      {row.attribute_name}
                      {isMarked && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>

                    <StyledTableCell
                      align="center"
                      className="table-cell-border"
                    >
                      {row.attribute_value}
                      {isMarked && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>

                    <StyledTableCell
                      align="center"
                      className="table-cell-border"
                    >
                      <div>
                        <input
                          type="number"
                          value={
                            selectedQuantity[
                              row.event_issue_product_details_id
                            ] !== undefined
                              ? selectedQuantity[
                                  row.event_issue_product_details_id
                                ]
                              : row.quantity || 1
                          }
                          onChange={(e) =>
                            handleQuantityChange(
                              row.event_issue_product_details_id,
                              e.target.value,
                              row.stock,
                              row.product_id,
                            )
                          }
                          style={{ width: "60px" }}
                        />
                        {validationErrors[
                          row.event_issue_product_details_id
                        ] && (
                          <div style={{ color: "red", marginTop: "5px" }}>
                            {
                              validationErrors[
                                row.event_issue_product_details_id
                              ]
                            }
                          </div>
                        )}
                      </div>
                      {isMarked && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>

                    <StyledTableCell
                      align="center"
                      className="table-cell-border"
                    >
                      {row.stock}
                      {isMarked && (
                        <div className="centered-red-line-store-purchase" />
                      )}
                    </StyledTableCell>

                    <StyledTableCell
                      align="center"
                      style={{ lineHeight: "10px", padding: "5px" }}
                    >
                      <IconButton
                        color="black"
                        onClick={() =>
                          handleRowDeleteClick(
                            row.event_issue_product_details_id,
                          )
                        }
                      >
                        <DeleteIcon />
                      </IconButton>
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        style={{ backgroundColor: "#0A64A2", color: "#fff" }}
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={allProducts.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      {/* 
         
            {/* Product Selection Dialog */}
      <Dialog
        open={openstaff}
        onClose={handleClosestaff}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" }, // Set the width to 300px
        }}
      >
        <DialogContent style={{ paddingLeft: "15px" }}>
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }} // Center align text
          >
            Kindly select an Event before selecting any products.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            onClick={handleClosestaff}
            className="no-btn"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      {/*EventIssue Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" },
        }}
      >
        <DialogContent style={{ paddingLeft: "15px" }}>
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }}
          >
            {markedForDelete.length > 0
              ? "Are you sure you want to delete this selected Product(s)?"
              : "Please select product(s) before deleting."}
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "flex-end" }}>
          {markedForDelete.length > 0 && (
            <Button
              variant="contained"
              onClick={handleConfirmDelete}
              sx={{
                backgroundColor: "#0A64A2",
                "&:hover": {
                  backgroundColor: "#084c7a", // slightly darker shade for hover
                },
              }}
            >
              Yes
            </Button>
          )}
          <Button
            variant="contained"
            onClick={() => {
              setMarkedForDelete([]); // ✅ Clear red line selection
              handleClose(); // ✅ Close dialog
            }}
            sx={{
              backgroundColor: "#0A64A2",
              "&:hover": {
                backgroundColor: "#084c7a", // same hover effect as Yes
              },
            }}
            autoFocus
          >
            {markedForDelete.length > 0 ? "No" : "Ok"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Needs Return Dialog */}
      <Dialog
        open={openNeedsReturn}
        onClose={handleCloseNeedsReturn}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" }, // Set the width to 300px
        }}
      >
        <DialogContent style={{ paddingLeft: "15px" }}>
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }} // Center align text
          >
            {needsReturn
              ? `Are you sure you want to mark Indent Id  returnable?`
              : `Are you sure you want to mark Indent Id  non-returnable?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            // onClick={handleCheckboxClick}
            autoFocus
            className="no-btn"
          >
            Yes
          </Button>
          <Button
            variant="contained"
            onClick={handleCloseNeedsReturn}
            autoFocus
            className="no-btn"
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for errors */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          // onClose={handleCloseSnackbar}
          severity="error"
          variant="filled"
        >
          {error}
        </Alert>
      </Snackbar>
    </div>
  );
}
